(function () {
  /* ==========================================================
     IMAGES
     Images live in the theme "assets" folder (flat, no sub-folders).
     flatName() turns  images/iron-and-blood/liposomal-iron.jpg
     into              iron-and-blood-liposomal-iron.jpg
     IMAGE_BASE comes from the liquid section (asset folder URL).
     prepare_images.py uses the SAME rule to rename the files.
     ========================================================== */
  const IMAGE_BASE = window.BL_IMAGE_BASE || "";
  const FALLBACK_IMAGE = "images/iron-and-blood/liposomal-iron.jpg";
  function flatName(path) {
    const parts = path.split("/").slice(-2);
    const file = parts.pop();
    const dot = file.lastIndexOf(".");
    const stem = file.slice(0, dot);
    const ext = file.slice(dot).toLowerCase();
    const clean = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
    return parts.map(clean).concat(clean(stem)).join("-") + ext;
  }
  function imgUrl(path) { return IMAGE_BASE + flatName(path); }

  /* Full Ingredients Data (36 Items) */
  const INGREDIENTS = [
    { id: "liposomal-iron", name: "Liposomal Iron", scientific_name: "Ferric Pyrophosphate (Lecithin Encapsulated)", category_id: "iron-and-blood", category_name: "Iron & Blood Vitality", product_name: "Ferrimune", simple_benefit: "Boosts hemoglobin & energy with zero nausea or constipation", clinical_evidence: "+2.1 g/dL Hb elevation • 91% fewer GI complaints", image: "images/iron-and-blood/liposomal-iron.jpg", summary: "Encapsulated in phospholipid spheres that shield the stomach lining and absorb directly through intestinal lymphatic pathways.", standard: "30 mg Elemental Iron", product_price: "₹1,299", product_url: "/products/ferrimune", type: "chelated-mineral" },
    { id: "vitamin-c", name: "Vitamin C", scientific_name: "Ascorbic Acid (USP-Grade)", category_id: "iron-and-blood", category_name: "Iron & Blood Vitality", product_name: "Ferrimune", simple_benefit: "Triples dietary and supplementary iron absorption", clinical_evidence: "300% increase in non-heme iron uptake", image: "images/iron-and-blood/vitamin-c.jpg", summary: "Reduces non-absorbable ferric iron into soluble ferrous state while supporting antioxidant collagen defense.", standard: "100 mg", product_price: "₹1,299", product_url: "/products/ferrimune", type: "bioactive-vitamin" },
    { id: "vitamin-b12", name: "Vitamin B12", scientific_name: "Methylcobalamin (Active Coenzyme)", category_id: "iron-and-blood", category_name: "Iron & Blood Vitality", product_name: "Ferrimune", simple_benefit: "Rebuilds red blood cells and clears brain fog & fatigue", clinical_evidence: "MCV normalization within 14 days • 38% homocysteine reduction", image: "images/iron-and-blood/Vitamin B12 (Methylcobalamin).jpg", summary: "The bioactive methylated form of B12 that bypasses liver activation to directly fuel nerve myelin sheath repair.", standard: "2.2 mcg (100% RDA)", product_price: "₹1,299", product_url: "/products/ferrimune", type: "bioactive-vitamin" },
    { id: "l-methylfolate", name: "L-Methylfolate", scientific_name: "Quatrefolic® [6S]-5-MTHF", category_id: "iron-and-blood", category_name: "Iron & Blood Vitality", product_name: "Ferrimune", simple_benefit: "Pre-metabolized active folate for DNA cellular renewal", clinical_evidence: "Bypasses MTHFR gene mutations • 0% unmetabolized folic acid", image: "images/iron-and-blood/L-Methylfolate.jpg", summary: "Unlike synthetic folic acid, 5-MTHF enters red blood cells directly to prevent neural defects and support healthy cell division.", standard: "300 mcg", product_price: "₹1,299", product_url: "/products/ferrimune", type: "bioactive-vitamin" },
    { id: "zinc-bisglycinate", name: "Zinc Bisglycinate", scientific_name: "True Amino Acid Chelate", category_id: "iron-and-blood", category_name: "Iron & Blood Vitality", product_name: "Ferrimune", simple_benefit: "Gentle chelated zinc that absorbs without competing with iron", clinical_evidence: "+43.4% greater plasma absorption • 100% stomach tolerance", image: "images/iron-and-blood/Zinc Bisglycinate.jpg", summary: "Bound between two glycine molecules to pass through the stomach intact and absorb via peptide channels.", standard: "15 mg Elemental Zinc", product_price: "₹1,299", product_url: "/products/ferrimune", type: "chelated-mineral" },
    { id: "copper", name: "Bio-Copper", scientific_name: "Copper Gluconate", category_id: "iron-and-blood", category_name: "Iron & Blood Vitality", product_name: "Ferrimune", simple_benefit: "Mandatory catalyst for ceruloplasmin iron transport", clinical_evidence: "Prevents microcytic anemia from isolated iron therapy", image: "images/iron-and-blood/Copper.jpg", summary: "Essential trace mineral maintaining copper-zinc equilibrium and activating the enzymatic incorporation of iron into hemoglobin.", standard: "1.7 mg", product_price: "₹1,299", product_url: "/products/ferrimune", type: "chelated-mineral" },
    { id: "selenium", name: "Selenium", scientific_name: "L-Selenomethionine (Organic)", category_id: "iron-and-blood", category_name: "Iron & Blood Vitality", product_name: "Ferrimune", simple_benefit: "Catalyzes glutathione peroxidase antioxidant enzymes", clinical_evidence: "-34% lipid peroxidation • -38% systemic hs-CRP inflammation", image: "images/iron-and-blood/Selenium.jpg", summary: "Protects red blood cell membranes against oxidative fragility and supports healthy thyroid T3 activation.", standard: "40 mcg", product_price: "₹1,299", product_url: "/products/ferrimune", type: "chelated-mineral" },
    { id: "alpha-lipoic-acid", name: "Alpha-Lipoic Acid (ALA)", scientific_name: "Thioctic Acid", category_id: "iron-and-blood", category_name: "Iron & Blood Vitality", product_name: "Ferrimune", simple_benefit: "Universal cellular antioxidant that recycles Vitamins C and E", clinical_evidence: "Reactivates endogenous intracellular glutathione depots", image: "images/iron-and-blood/Alpha-Lipoic Acid (ALA).jpg", summary: "Both water and fat soluble, ALA neutralizes free radicals across cell membranes and enhances cellular energy metabolism.", standard: "50 mg", product_price: "₹1,299", product_url: "/products/ferrimune", type: "bioactive-cofactor" },
    { id: "beetroot-extract", name: "Beetroot Extract", scientific_name: "Beta vulgaris (Standardized Nitrates)", category_id: "iron-and-blood", category_name: "Iron & Blood Vitality", product_name: "Ferrimune", simple_benefit: "Rich in natural dietary nitrates to enhance oxygen delivery", clinical_evidence: "Promotes microvascular vasodilation and tissue perfusion", image: "images/iron-and-blood/Beetroot Extract.jpg", summary: "Botanical nitrate donor that converts into nitric oxide, opening micro-capillaries to deliver iron and nutrients to fatigued tissues.", standard: "100 mg", product_price: "₹1,299", product_url: "/products/ferrimune", type: "clinical-botanical" },
    { id: "cranberry-extract", name: "Cranberry Extract (36mg PACs)", scientific_name: "Vaccinium macrocarpon (DMAC-Standardized)", category_id: "urinary-and-bladder", category_name: "Urinary & Bladder Health", product_name: "Cindoria", simple_benefit: "Stops bacteria from sticking to bladder walls", clinical_evidence: "54% reduction in recurring UTIs (Cochrane Review verified)", image: "images/urinary-and-bladder/Cranberry Powder and Fresh Berriesocal fres fresh berries.png", summary: "Contains active A-type proanthocyanidins that block uropathogenic E. coli fimbriae from latching onto urothelial linings.", standard: "36 mg Type-A PACs", product_price: "₹899", product_url: "/products/cindoria", type: "clinical-botanical" },
    { id: "d-mannose", name: "D-Mannose", scientific_name: "Natural Aldo-Hexose", category_id: "urinary-and-bladder", category_name: "Urinary & Bladder Health", product_name: "Cindoria", simple_benefit: "Traps and flushes urinary bacteria without antibiotics", clinical_evidence: "Matches antibiotic efficacy with 4x fewer side effects", image: "images/urinary-and-bladder/D-Mannose.jpg", summary: "Passes unmetabolized into urine, binding bacterial FimH receptors so bacteria are harmlessly flushed out during urination.", standard: "500 mg", product_price: "₹899", product_url: "/products/cindoria", type: "bioactive-cofactor" },
    { id: "hibiscus-extract", name: "Hibiscus Extract", scientific_name: "Hibiscus sabdariffa (Organic Acids)", category_id: "urinary-and-bladder", category_name: "Urinary & Bladder Health", product_name: "Cindoria", simple_benefit: "Soothes burning and clears resistant bacterial biofilms", clinical_evidence: "77% reduction in urinary discomfort • 82% biofilm inhibition", image: "images/urinary-and-bladder/Hibiscus Flower Extract.jpg", summary: "Rich in hibiscus acid and anthocyanins that provide soothing spasmolytic comfort and disrupt protective bacterial biofilms.", standard: "250 mg", product_price: "₹899", product_url: "/products/cindoria", type: "clinical-botanical" },
    { id: "dandelion-leaf-extract", name: "Dandelion Leaf Extract", scientific_name: "Taraxacum officinale", category_id: "urinary-and-bladder", category_name: "Urinary & Bladder Health", product_name: "Cindoria", simple_benefit: "Gentle botanical aquaretic for natural bladder cleansing", clinical_evidence: "Increases urinary frequency without potassium loss", image: "images/urinary-and-bladder/Dandelion Leaf Extract.jpg", summary: "Potassium-sparing botanical diuretic that promotes natural bladder emptying to clear trapped micro-organisms.", standard: "150 mg", product_price: "₹899", product_url: "/products/cindoria", type: "clinical-botanical" },
    { id: "myo-inositol", name: "Myo-Inositol", scientific_name: "cis-1,2,3,5-trans-4,6-cyclohexanehexol", category_id: "pcos-and-hormones", category_name: "PCOS & Hormonal Balance", product_name: "MaternaBloom", simple_benefit: "Restores regular menstrual cycles and spontaneous ovulation", clinical_evidence: "72% regular ovulation restored • -52% free testosterone in PCOS", image: "images/pcos-and-hormones/myo-inositol.jpg", summary: "Crucial second messenger for FSH signaling and cellular glucose disposal that calms ovarian androgen overproduction.", standard: "400 mg", product_price: "₹1,199", product_url: "/products/maternabloom", type: "bioactive-cofactor" },
    { id: "d-chiro-inositol", name: "D-Chiro-Inositol (40:1)", scientific_name: "D-Chiro-Inositol Carob Extract", category_id: "pcos-and-hormones", category_name: "PCOS & Hormonal Balance", product_name: "MaternaBloom", simple_benefit: "Balances ovarian epimerase in the precise 40:1 ratio", clinical_evidence: "86% spontaneous ovulation in insulin-resistant cohorts", image: "images/pcos-and-hormones/D-Chiro-Inositol Crystal Scoop.png", summary: "Formulated in the physiological 40:1 ratio with Myo-Inositol to stimulate glycogen synthesis without stressing egg quality.", standard: "10 mg (Exact 40:1 Ratio)", product_price: "₹1,199", product_url: "/products/maternabloom", type: "bioactive-cofactor" },
    { id: "vitex-chaste-berry", name: "Vitex (Chaste Tree Berry)", scientific_name: "Vitex agnus-castus (Standardized Aucubin)", category_id: "pcos-and-hormones", category_name: "PCOS & Hormonal Balance", product_name: "MaternaBloom", simple_benefit: "Normalizes luteal phase and progesterone-to-estrogen ratio", clinical_evidence: "Significant suppression of mild hyperprolactinemia", image: "images/pcos-and-hormones/Vitex ,Chaste Berry.jpg", summary: "Modulates dopamine D2 receptors in the pituitary to calm excess prolactin and support regular monthly cycle predictability.", standard: "80 mg", product_price: "₹1,199", product_url: "/products/maternabloom", type: "clinical-botanical" },
    { id: "chromium-picolinate", name: "Chromium Picolinate", scientific_name: "Bioavailable Trivalent Cr3+", category_id: "pcos-and-hormones", category_name: "PCOS & Hormonal Balance", product_name: "MaternaBloom", simple_benefit: "Curbs sugar cravings and enhances cellular insulin receptivity", clinical_evidence: "-3.2 µIU/mL fasting insulin • 32% improvement in HOMA-IR", image: "images/pcos-and-hormones/Chromium Picolinate.jpg", summary: "Forms chromodulin to amplify insulin receptor kinase activity 8-fold, reducing the hyperinsulinemic drive behind PCOS.", standard: "200 mcg (50% RDA)", product_price: "₹1,199", product_url: "/products/maternabloom", type: "chelated-mineral" },
    { id: "vitamin-d3", name: "Vitamin D3", scientific_name: "Cholecalciferol (100% RDA)", category_id: "pcos-and-hormones", category_name: "PCOS & Hormonal Balance", product_name: "MaternaBloom", simple_benefit: "Normalizes ovarian AMH levels and supports endometrial receptivity", clinical_evidence: "+44% increase in clinical conception rate in replete states", image: "images/pcos-and-hormones/Vitamin D3.jpg", summary: "Acts as an essential nuclear steroid hormone regulating granulosa cell maturation, immune tolerance, and ovarian reserve.", standard: "600 IU (15 mcg)", product_price: "₹1,199", product_url: "/products/maternabloom", type: "bioactive-vitamin" },
    { id: "evening-primrose-oil", name: "Evening Primrose Oil (GLA)", scientific_name: "Oenothera biennis (Standardized GLA)", category_id: "pcos-and-hormones", category_name: "PCOS & Hormonal Balance", product_name: "PeriHarmon", simple_benefit: "Relieves cyclic breast tenderness and hydrates hormonal dry skin", clinical_evidence: "78% relief from cyclical breast pain • 31% skin elasticity increase", image: "images/pcos-and-hormones/Evening Primrose Oil (GLA).jpg", summary: "Provides pre-formed Gamma-Linolenic Acid (GLA) which converts into anti-inflammatory Prostaglandin E1 (PGE1) to calm PMS.", standard: "Cold-Pressed 1,000 mg", product_price: "₹1,199", product_url: "/products/periharmon", type: "clinical-botanical" },
    { id: "coenzyme-q10", name: "Coenzyme Q10 (Ubiquinone)", scientific_name: "Fermented Pure Ubiquinone", category_id: "fertility-and-conception", category_name: "Fertility & Conception", product_name: "FertiliNova", simple_benefit: "Powers egg cell mitochondria and protects meiotic spindle", clinical_evidence: "44% drop in oocyte chromosomal aneuploidies • Fertilization up to 67.4%", image: "images/fertility-and-conception/Coenzyme Q10.jpg", summary: "Mature human eggs contain over 100,000 mitochondria; CoQ10 provides the cellular ATP needed for error-free chromosomal division.", standard: "100 mg", product_price: "₹1,499", product_url: "/products/fertilinova", type: "bioactive-cofactor" },
    { id: "astaxanthin", name: "Astaxanthin", scientific_name: "Haematococcus pluvialis Microalgae Extract", category_id: "fertility-and-conception", category_name: "Fertility & Conception", product_name: "FertiliNova", simple_benefit: "6,000× stronger than Vitamin C at shielding egg cell membranes", clinical_evidence: "Quenches singlet oxygen and peroxyl free radicals in follicular fluid", image: "images/fertility-and-conception/Astaxanthin.jpg", summary: "Nature's premier carotenoid antioxidant that preserves follicular microenvironments against age-related oxidative degradation.", standard: "6 mg", product_price: "₹1,499", product_url: "/products/fertilinova", type: "clinical-botanical" },
    { id: "iodine", name: "Potassium Iodide", scientific_name: "Bio-Iodine (100% RDA)", category_id: "fertility-and-conception", category_name: "Fertility & Conception", product_name: "FertiliNova", simple_benefit: "Critical preconception thyroid substrate for early fetal brain development", clinical_evidence: "Essential ICMR DRI micronutrient for maternal endocrine balance", image: "images/fertility-and-conception/Iodine.jpg", summary: "Mandatory building block for maternal thyroxine (T4) synthesis, safeguarding neuro-cognitive embryogenesis.", standard: "140 mcg", product_price: "₹1,499", product_url: "/products/fertilinova", type: "chelated-mineral" },
    { id: "melatonin", name: "Melatonin", scientific_name: "Preovulatory Indolamine", category_id: "fertility-and-conception", category_name: "Fertility & Conception", product_name: "FertiliNova", simple_benefit: "Accumulates in follicular fluid to protect oocyte DNA from oxidative injury", clinical_evidence: "-60% follicular DNA damage • 2.5× Grade-A blastocysts", image: "images/fertility-and-conception/Melatonin.jpg", summary: "Naturally concentrates 3-fold higher in ovarian follicular fluid than blood to shield egg chromosomes during maturation.", standard: "3 mg", product_price: "₹1,499", product_url: "/products/fertilinova", type: "bioactive-cofactor" },
    { id: "l-arginine", name: "L-Arginine", scientific_name: "Free-Form Amino Acid", category_id: "fertility-and-conception", category_name: "Fertility & Conception", product_name: "FertiliNova", simple_benefit: "Promotes healthy uterine artery blood flow and endometrial thickness", clinical_evidence: "Lining increased 6.2 mm → 9.1 mm • 3× implantation success", image: "images/fertility-and-conception/L-Arginine.jpg", summary: "Precursor to endothelial nitric oxide (NO) which dilates spiral arterioles feeding the receptive endometrial lining.", standard: "500 mg", product_price: "₹1,499", product_url: "/products/fertilinova", type: "amino-acid" },
    { id: "n-acetyl-cysteine", name: "N-Acetyl Cysteine (NAC)", scientific_name: "Cellular Glutathione Precursor", category_id: "fertility-and-conception", category_name: "Fertility & Conception", product_name: "FertiliNova", simple_benefit: "Improves fertile cervical mucus flow & replenishes glutathione", clinical_evidence: "52.1% ovulation induction in resistant cohorts • 78% cervical score improvement", image: "images/fertility-and-conception/N-Acetyl Cysteine (NAC).jpg", summary: "Cleaves mucin disulfide bonds to optimize sperm-penetrable cervical mucus while shielding ovarian granulosa cells.", standard: "600 mg", product_price: "₹1,499", product_url: "/products/fertilinova", type: "amino-acid" },
    { id: "black-cohosh", name: "Black Cohosh", scientific_name: "Cimicifuga racemosa (Standardized Actein)", category_id: "menopause-balance", category_name: "Perimenopause & Menopause", product_name: "PeriHarmon", simple_benefit: "Stabilizes brain temperature control to cool hot flashes and night sweats", clinical_evidence: "-80% Kupperman Index • -74% hot flash reduction (Zero uterine stimulation)", image: "images/menopause-balance/Black Cohosh.jpg", summary: "Binds central serotonin 5-HT1A receptors in the hypothalamus without stimulating breast or uterine tissue.", standard: "40 mg Standardized Extract", product_price: "₹1,299", product_url: "/products/periharmon", type: "clinical-botanical" },
    { id: "red-clover", name: "Red Clover Isoflavones", scientific_name: "Trifolium pratense (Quad-Isoflavone)", category_id: "menopause-balance", category_name: "Perimenopause & Menopause", product_name: "PeriHarmon", simple_benefit: "Provides 4 gentle plant isoflavones for cardiovascular & bone vitality", clinical_evidence: "-62% hot flash frequency • -68% decrease in night sweats", image: "images/menopause-balance/Red Clover Isoflavones.jpg", summary: "Delivers four distinct phytoestrogens that support healthy arterial elasticity and prevent bone calcium loss during menopause.", standard: "75 mg (providing 30mg Isoflavones)", product_price: "₹1,299", product_url: "/products/periharmon", type: "clinical-botanical" },
    { id: "saffron-extract", name: "Saffron Extract", scientific_name: "Crocus sativus (Standardized Crocin & Safranal)", category_id: "menopause-balance", category_name: "Perimenopause & Menopause", product_name: "PeriHarmon", simple_benefit: "Clinically uplifts menopausal mood, irritability & sleep quality", clinical_evidence: "Rebalances serotonin & dopamine with clinical superiority over placebo", image: "images/menopause-balance/Saffron Extract.jpg", summary: "Pure crimson stigma extract standardized for crocin to naturally modulate serotonin and dopamine reuptake.", standard: "15 mg", product_price: "₹1,299", product_url: "/products/periharmon", type: "clinical-botanical" },
    { id: "vitamin-k2", name: "Vitamin K2 (MK-7)", scientific_name: "Menaquinone-7 (Fermented Chickpea)", category_id: "menopause-balance", category_name: "Perimenopause & Menopause", product_name: "PeriHarmon", simple_benefit: "Activates osteocalcin to direct calcium into bones not arteries", clinical_evidence: "Prevents postmenopausal bone density loss and arterial calcification", image: "images/menopause-balance/Vitamin K2 (MK-7).jpg", summary: "The all-trans MK-7 format stays active in circulation for 72 hours, ensuring bone remodeling enzymes receive continuous activation.", standard: "55 mcg (100% RDA)", product_price: "₹1,299", product_url: "/products/periharmon", type: "bioactive-vitamin" },
    { id: "vitamin-b6", name: "Vitamin B6 (P-5-P)", scientific_name: "Pyridoxal-5-Phosphate (Active Coenzyme)", category_id: "menopause-balance", category_name: "Perimenopause & Menopause", product_name: "PeriHarmon", simple_benefit: "Mandatory coenzyme for serotonin production and water-weight balance", clinical_evidence: "2.3× higher efficacy in emotional stabilization • -65% bloating", image: "images/menopause-balance/Vitamin B6 (P-5-P).jpg", summary: "Active P-5-P format acts instantly in the nervous system to synthesize inhibitory GABA and regulate hormonal water retention.", standard: "25 mg", product_price: "₹1,299", product_url: "/products/periharmon", type: "bioactive-vitamin" },
    { id: "ashwagandha-ksm66", name: "Ashwagandha (KSM-66®)", scientific_name: "Withania somnifera (Full-Spectrum Root)", category_id: "muscle-and-recovery", category_name: "Muscle, Adaptogens & Recovery", product_name: "ProteoDiva & PeriHarmon", simple_benefit: "Lowers stress cortisol by 28% and speeds post-workout recovery", clinical_evidence: "-27.9% serum cortisol • -44% perceived stress • 38% less muscle soreness", image: "images/muscle-and-recovery/ashwagandha-ksm66.jpg", summary: "Proprietary full-spectrum root extract with highest concentration of withanolides to regulate the HPA stress axis and boost stamina.", standard: "300 mg KSM-66®", product_price: "₹1,299", product_url: "/products/proteodiva", type: "clinical-botanical" },
    { id: "shatavari-root", name: "Shatavari Root Extract", scientific_name: "Asparagus racemosus (Shatavarins I–IV)", category_id: "muscle-and-recovery", category_name: "Muscle, Adaptogens & Recovery", product_name: "ProteoDiva & PeriHarmon", simple_benefit: "Supports female muscle rejuvenation, hydration and hormonal vitality", clinical_evidence: "73% reduction in dryness • Selective ERβ agonist (zero oncogenic risk)", image: "images/muscle-and-recovery/shatavari-root.jpg", summary: "Queen of Ayurvedic herbs rich in steroidal saponins that support adrenal stamina, tissue hydration, and natural female vitality.", standard: "250 mg Standardized Extract", product_price: "₹1,299", product_url: "/products/proteodiva", type: "clinical-botanical" },
    { id: "curcumin-95", name: "Curcumin 95%", scientific_name: "Curcuma longa (Standardized Curcuminoids)", category_id: "muscle-and-recovery", category_name: "Muscle, Adaptogens & Recovery", product_name: "ProteoDiva", simple_benefit: "Halts inflammatory NF-κB to soothe sore muscles and protect joints", clinical_evidence: "-58% hs-CRP chronic inflammation • Equivalent to NSAIDs for mobility", image: "images/muscle-and-recovery/Curcumin 95%.jpg", summary: "Standardized 95% curcuminoids suppress exercise-induced inflammatory cytokines without damaging the stomach lining.", standard: "100 mg (95% Curcuminoids)", product_price: "₹1,299", product_url: "/products/proteodiva", type: "clinical-botanical" },
    { id: "hydrolyzed-protein-peptides", name: "Hydrolyzed Protein Peptides", scientific_name: "Pre-Cleaved Di- & Tri-Peptides", category_id: "muscle-and-recovery", category_name: "Muscle, Adaptogens & Recovery", product_name: "ProteoDiva", simple_benefit: "Pre-digested peptides that absorb in 25 minutes for lean muscle tone", clinical_evidence: "+40% higher muscle protein synthesis (MPS) • Sustained GLP-1 satiety", image: "images/muscle-and-recovery/Hydrolyzed Protein Peptides.jpg", summary: "Absorbs across PEPT1 intestinal channels twice as fast as whole proteins to reverse fatigue and maintain lean metabolic tissue.", standard: "30 g Clean Protein per 100g", product_price: "₹1,299", product_url: "/products/proteodiva", type: "amino-acid" },
    { id: "jivanti-extract", name: "Jivanti Extract", scientific_name: "Leptadenia reticulata", category_id: "muscle-and-recovery", category_name: "Muscle, Adaptogens & Recovery", product_name: "ProteoDiva", simple_benefit: "Revered Rasayana herb for cellular vitality and microvascular health", clinical_evidence: "Enhances cellular endurance and lactogenic micro-nutritional nourishment", image: "images/muscle-and-recovery/Jivanti Extract.jpg", summary: "Classic Ayurvedic rejuvenating botanical that supports energy economy, cellular oxygenation, and tissue recovery.", standard: "100 mg", product_price: "₹1,299", product_url: "/products/proteodiva", type: "clinical-botanical" },
    { id: "omega-3-dha-epa", name: "Omega-3 (DHA & EPA)", scientific_name: "Docosahexaenoic & Eicosapentaenoic Acids", category_id: "muscle-and-recovery", category_name: "Muscle, Adaptogens & Recovery", product_name: "ProteoDiva", simple_benefit: "Essential fatty acids supporting heart, brain and joint fluidity", clinical_evidence: "Replaces arachidonic acid in cell membranes to halt inflammatory cascade", image: "images/muscle-and-recovery/Omega-3 (DHA & EPA).jpg", summary: "Pure essential omega-3 fatty acids that preserve brain neuronal plasticity and lubricate connective joints.", standard: "DHA + EPA Complex", product_price: "₹1,299", product_url: "/products/proteodiva", type: "bioactive-cofactor" }
  ];

  /* Category Metadata */
  const CATEGORIES = [
    {
      id: "all",
      label: "All Ingredients",
      emoji: "✦",
      count: INGREDIENTS.length,
      banner: "images/iron-and-blood/category-banner.jpg",
      heading: INGREDIENTS.length + " Nutraceutical Ingredients",
      desc: "Standardized botanical extracts, chelated minerals, and bioactive coenzymes formulated specifically for women."
    },
    {
      id: "iron-and-blood",
      label: "Iron & Blood Vitality",
      emoji: "🩸",
      count: 9,
      banner: "images/iron-and-blood/category-banner.jpg",
      heading: "Iron & Blood Vitality Actives",
      desc: "Liposomal chelated minerals and synergistic co-factors delivering non-constipating hemoglobin elevation."
    },
    {
      id: "urinary-and-bladder",
      label: "Urinary & Bladder Health",
      emoji: "💧",
      count: 4,
      banner: "images/urinary-and-bladder/category-banner.jpg",
      heading: "Urinary & Bladder Health Actives",
      desc: "Standardized Type-A PACs, D-Mannose and aquaretics disrupting recurrent bacterial urothelial adherence."
    },
    {
      id: "pcos-and-hormones",
      label: "PCOS & Hormonal Balance",
      emoji: "🌸",
      count: 6,
      banner: "images/pcos-and-hormones/category-banner.jpg",
      heading: "PCOS & Hormonal Endocrine Actives",
      desc: "Physiological 40:1 inositol isomers and pituitary-dopaminergic botanicals regulating ovulatory cycles."
    },
    {
      id: "fertility-and-conception",
      label: "Fertility & Conception",
      emoji: "👶",
      count: 6,
      banner: "images/fertility-and-conception/category-banner.jpg",
      heading: "Fertility & Oocyte Quality Actives",
      desc: "Mitochondrial bioenergetics, high-potency carotenoids, and uterine vasodilators for preconception health."
    },
    {
      id: "menopause-balance",
      label: "Perimenopause & Menopause",
      emoji: "🌿",
      count: 5,
      banner: "images/menopause-balance/category-banner.jpg",
      heading: "Perimenopause & Menopause Actives",
      desc: "Serotonergic phytoestrogens and neuro-active coenzymes relieving hot flashes, mood shifts, and sleep disturbance."
    },
    {
      id: "muscle-and-recovery",
      label: "Muscle, Adaptogens & Recovery",
      emoji: "⚡",
      count: 6,
      banner: "images/muscle-and-recovery/category-banner.jpg",
      heading: "Muscle & Adaptogenic Recovery Actives",
      desc: "Full-spectrum root extracts, pre-cleaved peptides, and cellular anti-inflammatories to lower cortisol and build tone."
    }
  ];

  /* Type Labels map */
  const TYPE_LABELS = {
    "clinical-botanical": "Botanical & Adaptogen",
    "chelated-mineral": "Chelated Mineral",
    "bioactive-vitamin": "Bioactive Vitamin",
    "amino-acid": "Amino Acid & Bio-Peptide",
    "bioactive-cofactor": "Bioactive & Co-factor"
  };

  /* Application State */
  let activeCategoryId = "all";
  let selectedTypes = new Set();
  let searchQuery = "";
  let sortOrder = "relevant";

  /* DOM Element References */
  const categoryPillsList = document.getElementById("categoryPillsList");
  const ingredientGrid = document.getElementById("ingredientGrid");
  const emptyState = document.getElementById("emptyState");
  const emptyResetBtn = document.getElementById("emptyResetBtn");
  const resultsHeading = document.getElementById("resultsHeading");
  const resultsCountBadge = document.getElementById("resultsCountBadge");
  const activeChipsWrap = document.getElementById("activeChipsWrap");
  const sidebarClearBtn = document.getElementById("sidebarClearBtn");
  const heroSearchInput = document.getElementById("heroSearchInput");
  const heroSearchBtn = document.getElementById("heroSearchBtn");
  const sidebarSortSelect = document.getElementById("sidebarSortSelect");
  const desktopSortSelect = document.getElementById("desktopSortSelect");
  const heroBannerVisual = document.getElementById("heroBannerVisual");
  const heroBannerImg = document.getElementById("heroBannerImg");
  heroBannerImg.src = imgUrl("images/iron-and-blood/category-banner.jpg");
  heroBannerImg.onerror = function () { this.onerror = null; this.src = imgUrl(FALLBACK_IMAGE); };
  const heroBannerTag = document.getElementById("heroBannerTag");
  const heroBannerHeading = document.getElementById("heroBannerHeading");
  const heroBannerDesc = document.getElementById("heroBannerDesc");
  const detailDrawer = document.getElementById("detailDrawer");
  const drawerOverlay = document.getElementById("drawerOverlay");
  const drawerCloseBtn = document.getElementById("drawerCloseBtn");
  const toastPill = document.getElementById("toastPill");
  const quizModalOverlay = document.getElementById("quizModalOverlay");
  const quizCloseBtn = document.getElementById("quizCloseBtn");
  const openQuizBtn = document.getElementById("openQuizBtn");

  /* Initialize Application */
  function init() {
    detailDrawer.inert = true;
    quizModalOverlay.inert = true;
    renderCategoryPills();
    bindEvents();
    applyFiltersAndRender();
  }

  /* Render Category Pills in Sidebar */
  function renderCategoryPills() {
    categoryPillsList.innerHTML = "";
    CATEGORIES.forEach(cat => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = `category-pill-tab ${cat.id === activeCategoryId ? "active" : ""}`;
      btn.dataset.id = cat.id;
      btn.innerHTML = `
          <span class="category-pill-label">
            <span class="category-emoji">${cat.emoji}</span>
            <span>${cat.label}</span>
          </span>
          <span class="category-badge-count">${cat.count}</span>
        `;
      btn.addEventListener("click", () => {
        setActiveCategory(cat.id);
      });
      categoryPillsList.appendChild(btn);
    });
  }

  /* Switch Active Category */
  function setActiveCategory(catId) {
    activeCategoryId = catId;
    // Update UI active class
    document.querySelectorAll(".category-pill-tab").forEach(tab => {
      tab.classList.toggle("active", tab.dataset.id === catId);
    });
    // Update Hero Banner Visual
    updateHeroBanner(catId);
    applyFiltersAndRender();
  }

  /* Update Hero Banner Image and Headings */
  function updateHeroBanner(catId) {
    const cat = CATEGORIES.find(c => c.id === catId) || CATEGORIES[0];
    heroBannerImg.style.opacity = "0.3";
    setTimeout(() => {
      heroBannerImg.src = imgUrl(cat.banner);
      heroBannerTag.textContent = catId === "all" ? "✦ MASTER COMPENDIUM" : `${cat.emoji} ${cat.label.toUpperCase()}`;
      heroBannerHeading.textContent = cat.heading;
      heroBannerDesc.textContent = cat.desc;
      heroBannerImg.style.opacity = "1";
    }, 150);
  }

  /* Bind Event Listeners */
  function bindEvents() {
    // Type checkboxes
    document.querySelectorAll(".type-filter-input").forEach(cb => {
      cb.addEventListener("change", (e) => {
        if (e.target.checked) {
          selectedTypes.add(e.target.value);
        } else {
          selectedTypes.delete(e.target.value);
        }
        applyFiltersAndRender();
      });
    });

    // Clear All in Sidebar & Empty State Reset
    sidebarClearBtn.addEventListener("click", resetAllFilters);
    emptyResetBtn.addEventListener("click", resetAllFilters);

    // Search Inputs
    heroSearchInput.addEventListener("input", (e) => {
      searchQuery = e.target.value.trim().toLowerCase();
      applyFiltersAndRender();
    });
    heroSearchBtn.addEventListener("click", () => {
      searchQuery = heroSearchInput.value.trim().toLowerCase();
      applyFiltersAndRender();
    });

    // Popular Searches Pills
    document.querySelectorAll(".popular-pill").forEach(pill => {
      pill.addEventListener("click", () => {
        const q = pill.dataset.query;
        heroSearchInput.value = q;
        searchQuery = q.toLowerCase();
        applyFiltersAndRender();
        // Smooth scroll to results
        document.querySelector(".content-header-bar").scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });

    // Sort Selects (Keep in sync)
    sidebarSortSelect.addEventListener("change", (e) => {
      sortOrder = e.target.value;
      desktopSortSelect.value = sortOrder;
      applyFiltersAndRender();
    });
    desktopSortSelect.addEventListener("change", (e) => {
      sortOrder = e.target.value;
      sidebarSortSelect.value = sortOrder;
      applyFiltersAndRender();
    });

    // Drawer Close Events
    drawerCloseBtn.addEventListener("click", closeDrawer);
    drawerOverlay.addEventListener("click", closeDrawer);
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        closeDrawer();
        closeQuizModal();
      }
    });

    // Newsletter form
    document.getElementById("newsletterSubmitBtn").addEventListener("click", () => {
      const email = document.getElementById("newsletterEmail").value;
      if (email && email.includes("@")) {
        showToast("Thank you for subscribing! Check your inbox for formulation insights.");
        document.getElementById("newsletterEmail").value = "";
      } else {
        showToast("Please enter a valid email address.");
      }
    });

    // Quiz Modal
    openQuizBtn.addEventListener("click", () => {
      quizModalOverlay.classList.add("active");
      quizModalOverlay.inert = false;
      quizCloseBtn.focus();
    });
    quizCloseBtn.addEventListener("click", closeQuizModal);
    quizModalOverlay.addEventListener("click", (e) => {
      if (e.target === quizModalOverlay) closeQuizModal();
    });
  }

  function closeQuizModal() {
    const wasOpen = quizModalOverlay.classList.contains("active");
    quizModalOverlay.classList.remove("active");
    quizModalOverlay.inert = true;
    if (wasOpen) openQuizBtn.focus();
  }

  window.setActiveCategory = setActiveCategory;
  window.applyQuizFocus = function (catId) {
    closeQuizModal();
    setActiveCategory(catId);
    document.querySelector(".content-header-bar").scrollIntoView({ behavior: "smooth" });
    showToast("Filtered by your health focus goal!");
  };

  /* Filter, Sort & Render Cards */
  function applyFiltersAndRender() {
    let filtered = INGREDIENTS.filter(item => {
      // 1. Category Filter
      if (activeCategoryId !== "all") {
        // If menopause-balance is chosen, Shatavari is also clinically dual-indicated
        const isCategoryMatch = item.category_id === activeCategoryId ||
          (activeCategoryId === "menopause-balance" && item.id === "shatavari-root");
        if (!isCategoryMatch) return false;
      }

      // 2. Type Checkbox Filter
      if (selectedTypes.size > 0 && !selectedTypes.has(item.type)) {
        return false;
      }

      // 4. Search Query Filter (Fuzzy substring across name, scientific_name, simple_benefit, category_name, product_name)
      if (searchQuery) {
        const matchTarget = `${item.name} ${item.scientific_name} ${item.simple_benefit} ${item.category_name} ${item.product_name} ${item.summary}`.toLowerCase();
        if (!matchTarget.includes(searchQuery)) {
          return false;
        }
      }

      return true;
    });

    // Sorting
    if (sortOrder === "name-asc") {
      filtered.sort((a, b) => a.name.localeCompare(b.name));
    } else if (sortOrder === "name-desc") {
      filtered.sort((a, b) => b.name.localeCompare(a.name));
    }

    // Render Grid
    renderGrid(filtered);

    // Render Header Title & Count
    const activeCat = CATEGORIES.find(c => c.id === activeCategoryId) || CATEGORIES[0];
    resultsHeading.textContent = activeCat.id === "all" ? "All Ingredients" : activeCat.label;
    resultsCountBadge.textContent = `Showing ${filtered.length} of ${INGREDIENTS.length}`;

    // Render Active Filter Chips
    renderActiveChips();
  }

  /* Render Cards into DOM */
  function renderGrid(items) {
    ingredientGrid.innerHTML = "";

    if (items.length === 0) {
      emptyState.classList.add("show");
    } else {
      emptyState.classList.remove("show");

      items.forEach(item => {
        const card = document.createElement("article");
        card.className = "ingredient-card";
        card.dataset.id = item.id;

        card.innerHTML = `
            <div class="card-media-wrap">
              <img 
                src="${imgUrl(item.image)}" 
                alt="${item.name}" 
                class="card-img" 
                loading="lazy"
                onerror="this.onerror=null; this.src='${imgUrl(FALLBACK_IMAGE)}';"
              >
            </div>
            
            <div class="card-body">
              <span class="card-category-pill">${item.category_name}</span>
              <h3 class="card-name"><button type="button" class="card-open-btn">${item.name}</button></h3>
              <p class="card-scientific">${item.scientific_name}</p>
              <p class="card-benefit">${item.simple_benefit}</p>
              
              <div class="card-clinical-badge" title="${item.clinical_evidence}">
                <svg viewBox="0 0 24 24"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
                <span>${item.clinical_evidence}</span>
              </div>
              
              <div class="card-product">Found in: ${productNamesHtml(item.product_name)}</div>
              
              <a href="javascript:void(0)" class="card-details-link">
                View Details <span>→</span>
              </a>
            </div>
          `;

        // Card Click -> Open Detail Drawer
        card.addEventListener("click", (e) => {
          // Let the product link work without opening the drawer
          if (e.target.closest(".card-product-link")) return;
          openDrawer(item.id);
        });

        ingredientGrid.appendChild(card);
      });
    }
  }

  /* Active Filter Chips Render */
  function renderActiveChips() {
    activeChipsWrap.innerHTML = "";

    // 1. Category chip (if not all)
    if (activeCategoryId !== "all") {
      const cat = CATEGORIES.find(c => c.id === activeCategoryId);
      if (cat) {
        const chip = document.createElement("span");
        chip.className = "filter-chip";
        chip.innerHTML = `${cat.label} <span class="chip-remove" onclick="setActiveCategory('all')">×</span>`;
        activeChipsWrap.appendChild(chip);
      }
    }

    // 2. Type chips
    selectedTypes.forEach(typeKey => {
      const label = TYPE_LABELS[typeKey] || typeKey;
      const chip = document.createElement("span");
      chip.className = "filter-chip";
      chip.innerHTML = `${label} <span class="chip-remove" data-type="${typeKey}">×</span>`;
      chip.querySelector(".chip-remove").addEventListener("click", () => {
        selectedTypes.delete(typeKey);
        document.querySelectorAll(`.type-filter-input[value="${typeKey}"]`).forEach(cb => cb.checked = false);
        applyFiltersAndRender();
      });
      activeChipsWrap.appendChild(chip);
    });

    // 3. Search query chip
    if (searchQuery) {
      const chip = document.createElement("span");
      chip.className = "filter-chip";
      chip.innerHTML = `Search: "${searchQuery}" <span class="chip-remove" id="clearSearchChip">×</span>`;
      chip.querySelector("#clearSearchChip").addEventListener("click", () => {
        searchQuery = "";
        heroSearchInput.value = "";
        applyFiltersAndRender();
      });
      activeChipsWrap.appendChild(chip);
    }
  }

  /* Reset All Filters */
  function resetAllFilters() {
    activeCategoryId = "all";
    selectedTypes.clear();
    searchQuery = "";
    sortOrder = "relevant";

    heroSearchInput.value = "";
    sidebarSortSelect.value = "relevant";
    desktopSortSelect.value = "relevant";

    document.querySelectorAll(".type-filter-input").forEach(cb => cb.checked = false);
    renderCategoryPills();
    updateHeroBanner("all");
    applyFiltersAndRender();
    showToast("All filters have been reset");
  }

  /* Product links (set in the theme editor / by handle, see the section file) */
  const PRODUCT_LINKS = window.BL_PRODUCTS || {};
  function productParts(name) {
    return name.split(" & ").map(n => n.trim()).filter(Boolean);
  }
  function getProductUrl(name) {
    if (PRODUCT_LINKS[name]) return PRODUCT_LINKS[name];
    const slug = name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
    return "/products/" + slug;
  }
  function productNamesHtml(name) {
    return productParts(name).map(n => {
      const url = getProductUrl(n);
      return `<a class="card-product-link" href="${url}"><strong>${n}</strong></a>`;
    }).join(" &amp; ");
  }

  /* Detail Drawer Interaction */
  function openDrawer(id) {
    const item = INGREDIENTS.find(i => i.id === id);
    if (!item) return;

    document.getElementById("drawerImg").src = imgUrl(item.image);
    document.getElementById("drawerImg").alt = item.name;
    document.getElementById("drawerCategoryPill").textContent = item.category_name;
    document.getElementById("drawerTypePill").textContent = TYPE_LABELS[item.type] || item.type;
    document.getElementById("drawerIngredientName").textContent = item.name;
    document.getElementById("drawerScientificName").textContent = item.scientific_name;
    document.getElementById("drawerClinicalText").textContent = item.clinical_evidence;
    document.getElementById("drawerSummaryText").textContent = item.summary;
    document.getElementById("drawerBenefitText").textContent = item.simple_benefit;
    document.getElementById("drawerDosageValue").textContent = item.standard;
    const prodNames = productParts(item.product_name);
    document.getElementById("drawerProductName").textContent = prodNames.join(" & ");
    const prodLinks = document.getElementById("drawerProductLinks");
    prodLinks.innerHTML = "";
    prodNames.forEach(n => {
      const url = getProductUrl(n);
      const a = document.createElement("a");
      a.className = "product-add-btn";
      a.href = url;
      a.textContent = "View " + n;
      prodLinks.appendChild(a);
    });

    // Explore More link inside drawer
    const exploreLink = document.getElementById("drawerExploreLink");
    exploreLink.textContent = `Explore all ${item.category_name} ingredients →`;
    exploreLink.onclick = () => {
      closeDrawer();
      setActiveCategory(item.category_id);
      document.querySelector(".content-header-bar").scrollIntoView({ behavior: "smooth" });
    };

    lastFocusEl = document.activeElement;
    drawerOverlay.classList.add("active");
    detailDrawer.classList.add("active");
    detailDrawer.inert = false;
    document.body.style.overflow = "hidden";
    drawerCloseBtn.focus();
  }

  let lastFocusEl = null;
  function closeDrawer() {
    const wasOpen = detailDrawer.classList.contains("active");
    drawerOverlay.classList.remove("active");
    detailDrawer.classList.remove("active");
    detailDrawer.inert = true;
    document.body.style.overflow = "";
    if (wasOpen && lastFocusEl && document.contains(lastFocusEl)) lastFocusEl.focus();
  }

  /* Toast Notification Helper */
  let toastTimeout;
  function showToast(message) {
    clearTimeout(toastTimeout);
    toastPill.textContent = message;
    toastPill.classList.add("show");
    toastTimeout = setTimeout(() => {
      toastPill.classList.remove("show");
    }, 2600);
  }

  // Run on load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

})();